import * as React from "react";

interface ThinkingMessageProps {
  text: string;
}

const ThinkingMessage: React.FC<ThinkingMessageProps> = ({ text }) => (
  <div className="thinking-message">
    <svg className="thinking-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
    <div className="thinking-text">{text}</div>
  </div>
);

export default ThinkingMessage;
